import $ from 'jquery'
window.$ = $;

import {} from "./libs/events";
import "./libs/calendar-plug";
import { getScreen } from "./libs/onScreen";
import { getStories } from "./libs/libStories";
import { getBlogs } from "./libs/blogCollect";
import { getLibCal } from "./libs/libcalHours";
import "./libs/tmlSearch";
import "./libs/scaSearch";
import {} from "./libs/megaMenu";
import {} from "metismenu/dist/metisMenu";
import MicroModal from "./libs/modal";
import "./libs/libAlerts";
import {} from "./libs/oompah.js";
import {} from "instant.page";
import {} from "./libs/sideNav";
import A11yDialog from 'a11y-dialog';


// const jbcTitle = "James Branch Cabell Library";
// const hslTitle = "Health Sciences Library";
// const jbcID = 15995;
// const hslID = 16561;


if (window.location.pathname == '/' || '') {
  getScreen();
  getStories();
  getBlogs();
}
if (window.location.pathname == '/about/giving/') {
  getStories();
}

// LibCal
getLibCal();


// pretty sure this is where apps pop up needs to be fixed
// note for now @cody
var els = document.querySelectorAll("a[href='/spaces-tech/reserve-a-study-room/']");
if (els.length !== 0) {
  els[0].setAttribute("data-custom-open", "modal-1");
  els[0].addEventListener("click", function (e) {
    e.preventDefault();
  });
  els[1].setAttribute("data-custom-open", "modal-1");
  els[1].addEventListener("click", function (e) {
    e.preventDefault();
  });
}

if (window.location.pathname == '/spaces-tech/') {
  let sidebar = document.querySelector(".u-location_sidebar_L > div > ul > li > a[href='/spaces-tech/reserve-a-study-room/']");
  sidebar.setAttribute("href", "#");
  sidebar.setAttribute("data-custom-open", "modal-1");
}

$("#metismenu").metisMenu({
  preventDefault: true,
});

$(".nav-main--toggle").click(function () {
  $("body").toggleClass("mobile-nav");
});

// import {} from './libs/specialistsDrop';

//TODO: this is terrible no one thinks it's good, let's fix it in post
$("select#equipment-select")
  .change(function () {
    $("select#equipment-select option:selected").each(function () {
      if ($(this).attr("value") == "value1") {
        $("table#value2, table#value3, table#value4, table#value5, table#value6, table#value7").hide();
        $("table#value1").show();
      }
      if ($(this).attr("value") == "value2") {
        $("table#value1, table#value3, table#value4, table#value5, table#value6, table#value7").hide();
        $("table#value2").show();
      }
      if ($(this).attr("value") == "value3") {
        $("table#value2, table#value4, table#value5, table#value6, table#value1, table#value7").hide();
        $("table#value3").show();
      }
      if ($(this).attr("value") == "value4") {
        $("table#value3, table#value2, table#value1, table#value5, table#value6, table#value7").hide();
        $("table#value4").show();
      }
      if ($(this).attr("value") == "value5") {
        $("table#value1, table#value2, table#value3, table#value4, table#value6, table#value7").hide();
        $("table#value5").show();
      }
      if ($(this).attr("value") == "value6") {
        $("table#value1, table#value2, table#value3, table#value4, table#value5, table#value7").hide();
        $("table#value6").show();
      }
      if ($(this).attr("value") == "value7") {
        $("table#value1, table#value2, table#value3, table#value4, table#value5, table#value6").hide();
        $("table#value7").show();
      }
    });
  })
  .change();
//end bad table script -- fin

MicroModal.init({
  openTrigger: "data-custom-open", // [3]
  closeTrigger: "data-micromodal-close", // [4]
  disableScroll: true, // [5]
  disableFocus: false, // [6]
  awaitCloseAnimation: true, // [7]
});

function toggleHidden(elem) {
  var attr = elem.attributes;

  if (attr["aria-hidden"].value == "true") {
    elem.setAttribute("aria-hidden", "false");
  } else {
    elem.setAttribute("aria-hidden", "true");
  }
}

const container = document.querySelector('#callnum-dialog');
if (container) {
  const dialog = new A11yDialog(container);
}

//chat pilot
var chatD = '<div class="needs-js">chat loading...</div>';
var chatF =
  '(function() {var x = document.createElement("script"); x.type = "text/javascript"; x.async = true;x.src = (document.location.protocol === "https:" ? "https://" : "http://") + "libraryh3lp.com/js/libraryh3lp.js?10497";var y = document.getElementsByTagName("script")[0]; y.parentNode.insertBefore(x, y);})()';
var chatScript = document.createElement("script");
chatScript.type = "text/javascript";
chatScript.text = chatF;

if (
  $(".u-location_main h1").html() == "Find &amp; Access" ||
  $(".u-location_main h1").html() == "Research &amp; Teaching Support" ||
  $(".u-location_main h1").html() == "Ask Us" ||
  $(".u-location_main h1").html() == "Hours" ||
  $(".u-location_main h1").html() == "James Branch Cabell Library Hours" ||
  $(".u-location_main h1").html() == "Health Sciences Library Hours" ||
  $(".u-location_main h1").html() == "Resources for graduate students" ||
  $(".u-location_main h1").html() == "Resources for VCU Faculty and Staff" ||
  $(".u-location_main h1").html() == "Resources for VCU Faculty and Staff" ||
  $(".u-location_main h1").html() == "Resources for undergraduate students" ||
  $(".u-no_margin_top").html() == "Interlibrary Loan and Delivery"
) {
   $(".container-secondary").append(chatD);
   document.body.appendChild(chatScript);
}

if (window.location.pathname == "/" || window.location.pathname ==
  '/spaces-tech/james-branch-cabell-library/cabell-library-floor-map/' || window.location.pathname == "/resources-for/undergraduate-students/" || window.location.pathname == "/research-teaching/instructional-support/"
) {
  $("body").append(chatD);
   document.body.appendChild(chatScript);
}
// browser window scroll (in pixels) after which the "back to top" link is shown
var offset = 300,
  //browser window scroll (in pixels) after which the "back to top" link opacity is reduced
  offset_opacity = 1200,
  //duration of the top scrolling animation (in ms)
  scroll_top_duration = 700,
  //grab the "back to top" link
  $back_to_top = $(".cd-top");

//hide or show the "back to top" link
$(window).scroll(function () {
  // $(this).scrollTop() > offset ? $back_to_top.addClass("cd-is-visible") : $back_to_top.removeClass("cd-is-visible cd-fade-out");
  if ($(this).scrollTop() > offset_opacity) {
    $back_to_top.addClass("cd-fade-out");
  }
});

//smooth scroll to top
$back_to_top.on("click", function (event) {
  event.preventDefault();
  $("body,html").animate(
    {
      scrollTop: 0,
    },
    scroll_top_duration
  );
});

//
$(function ($) {
  $(".trending--post__text-title a").click(function () {
    var Ilink = $(this).attr("href"); //Getting link from click
    var title = $(this).text(); //Getting title from click
    //alert(Ilink);

    //pushing value to data layer
    dataLayer.push({
      insightCategory: "Insights",
      insightTitle: title,
      insightLink: Ilink,
    });
  });
});
